import { render, staticRenderFns } from "./DSMonitoring.vue?vue&type=template&id=0b10e662"
import script from "./DSMonitoring.vue?vue&type=script&lang=js"
export * from "./DSMonitoring.vue?vue&type=script&lang=js"
import style0 from "./DSMonitoring.vue?vue&type=style&index=0&id=0b10e662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports